import { render, staticRenderFns } from "./EditarCodigo.vue?vue&type=template&id=963474b8&scoped=true&"
import script from "./EditarCodigo.vue?vue&type=script&lang=js&"
export * from "./EditarCodigo.vue?vue&type=script&lang=js&"
import style0 from "./EditarCodigo.vue?vue&type=style&index=0&id=963474b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963474b8",
  null
  
)

export default component.exports